export default class SettingsButton {
    constructor(scene) {
        const button =  scene.add.image(800 - 16, 16, `settings`, 0).setScale(1).setOrigin(1, 0).setScrollFactor(0).setInteractive();
        // button.width = 10;
        // button.height = 10;
        button.on('pointerdown', () => {
            // button.setTexture('buttoned_pressed');
            scene.scene.launch('Settings', {scene: scene.scene.key});
            scene.scene.sleep();
        }).on('pointerup', () => {
            // button.setTexture('button');
        });
        
            
    }
}